import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmtDate = (v) => v ? new Date(v).toLocaleString() : '—';

const AdminLoginHistory = () => {
  const { clientId } = useParams();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = clientId ? `?client_id=${encodeURIComponent(clientId)}&limit=500` : '?limit=500';
    axios.get(`${API}/admin/login-history${q}`)
      .then(r => setEvents(r.data))
      .catch(() => toast.error('Failed to load login history'))
      .finally(() => setLoading(false));
  }, [clientId]);

  return (
    <div className="p-8" data-testid="admin-login-history-page">
      <div className="mb-6">
        <div className="flex items-center gap-3">
          <h1 className="text-3xl font-bold text-brand-primary">
            {clientId ? 'Client Login History' : 'Client Activity — Recent Logins'}
          </h1>
          {clientId && <Link to="/admin/clients" className="text-sm text-brand-accent underline">Back to Clients</Link>}
        </div>
        <p className="text-slate-600 mt-1">
          {clientId
            ? 'Every successful login recorded for this client.'
            : 'Latest 500 client login events across the platform.'} Admin-only.
        </p>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 uppercase text-xs tracking-wider text-slate-600">
            <tr>
              {!clientId && <th className="p-3 text-left">Client</th>}
              <th className="p-3 text-left">Email</th>
              <th className="p-3 text-left">Login date</th>
              <th className="p-3 text-left">IP address</th>
              <th className="p-3 text-left">User agent</th>
            </tr>
          </thead>
          <tbody>
            {loading ? <tr><td colSpan={clientId ? 4 : 5} className="p-6 text-center text-slate-500">Loading…</td></tr>
              : events.length === 0 ? <tr><td colSpan={clientId ? 4 : 5} className="p-6 text-center text-slate-500">No logins recorded yet.</td></tr>
              : events.map(e => (
                <tr key={e.id} data-testid={`login-row-${e.id}`} className="border-t border-slate-100 hover:bg-slate-50">
                  {!clientId && <td className="p-3 font-medium">{e.full_name || '—'}</td>}
                  <td className="p-3 font-mono text-xs">{e.email}</td>
                  <td className="p-3 tabular-nums">{fmtDate(e.login_at)}</td>
                  <td className="p-3 font-mono text-xs">{e.ip || '—'}</td>
                  <td className="p-3 text-xs text-slate-500 truncate max-w-md" title={e.user_agent}>{e.user_agent || '—'}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminLoginHistory;
